import { getUserQueueRequest, getUserQueueRequestFailed } from '../redux/reducers/userSignInCard.reducer';
import { startProcess, downloadSigninCardProcessFail } from '../redux/reducers/downloadSigninCardProcess.reducer';
import { postContentPackageStart, postContentPackageFailure } from '../redux/actions/assetsPage';
import { courseUploadFailure, courseUploadStart } from '../redux/actions/courseUpload';
import { publishCourseDataFailure, publishCourseDataStart } from '../redux/actions/coursePublish';
import {
  loadStudentTodoTasksRequest,
  loadStudentTodoTasksFailure,
  loadStudentTasksRequest,
  loadStudentTasksFailure
} from '../redux/actions/placementTests';

/**
 * Polling config
 */
export const pollConfig = {
  stopAfterRetries: 2, // total time to stop polling - 4.30seconds
  throttleIntervalReset: 1,
  retries: 1,
  throttleInterval: [2, 3, 5, 7, 11, 13, 17, 19, 23, 29] // 2.15seconds
};

/**
 * Polling Action Events
 */
export const teacherPollingEvents = {
  MANAGED_USER_POLL: {
    apiFailed: getUserQueueRequestFailed(true),
    conditionToFulfil: getUserQueueRequest()
  },
  DOWNLOAD_SIGNIN_CARD_PROCESS: {
    apiFailed: downloadSigninCardProcessFail(),
    conditionToFulfil: startProcess()
  },
  POST_UPLOAD_CONTENT_PACKAGE_PROCESS: {
    apiFailed: postContentPackageFailure('Failed to upload the content package, REASON: "Timeout"'),
    conditionToFulfil: postContentPackageStart(),
    throttleInterval: [10, 10],
    stopAfterRetries: 30
  },
  COURSE_UPLOAD_PROCESS: {
    apiFailed: courseUploadFailure('Failed to upload the course content, REASON: "Timeout"'),
    conditionToFulfil: courseUploadStart(),
    throttleInterval: [20, 20],
    stopAfterRetries: 30
  },
  PUBLISH_COURSE_PROCESS: {
    apiFailed: publishCourseDataFailure('Failed to publish the course content, REASON: "Timeout"'),
    conditionToFulfil: publishCourseDataStart(),
    throttleInterval: [10, 10],
    stopAfterRetries: 30
  }
};

export const learnerPollingEvents = {
  GET_USER_TODO_TASKS: {
    apiFailed: loadStudentTodoTasksFailure(),
    conditionToFulfil: loadStudentTodoTasksRequest,

    // refresh rate at every 5 minutes (300 seconds) after first attempt (1 sec)
    // 6 * 300 + 1 = 1801 seconds => 30 minutes in total after 7 retries
    // stop after it runs 7 times
    throttleInterval: [1, 300],
    stopAfterRetries: 7
  },
  GET_USER_TASKS: {
    apiFailed: loadStudentTasksFailure(),
    conditionToFulfil: loadStudentTasksRequest,

    // refresh rate at every 1 minute (60 seconds) after first attempt (1 sec)
    // 30 * 60 + 1 = 1801 seconds => 30 minutes in total after 31 retries
    // stop after it runs 31 times
    throttleInterval: [1, 60],
    stopAfterRetries: 31
  }
};

export default {
  pollConfig,
  learnerPollingEvents,
  teacherPollingEvents
};
